import Helper from './helper';
const trans = {
    qq: '000012_qq',
    sogou: '000012_sogou',
    uc: '000012_uc',
    xm: '000012_xm', // 小米自带浏览器
    hw: '000011_hw', // 华为自带浏览器
    sjcl: '000013_sjcl', // 手机冲浪（app名叫冲浪导航）
    vivo: '000011_bbg', // vivo自带浏览器
    sll: '000012_360', // 360浏览器
    sogou_mz: '000012_sogou_mz', // 搜狗浏览器名站
}
export default {
    /**
     * @desc: 判断是否是指定渠道
     * @param: String 单个渠道
     *         Array  多个渠道，匹配任意一个返回true
    */
    isTransPort: (transName) => {
        let output = false
        const transCode = Helper.urlToObj(location.href)['_trans_']
        if(Object.prototype.toString.call(transName) === "[object Array]") {
            // 如果参数是数组
            if(transName && transName.length) {
                for(let i in transName) {
                    output = transCode && ~transCode.indexOf(trans[transName[i]])
                    if(output) break
                }
            }
        }else if(Object.prototype.toString.call(transName) === "[object String]") {
            // 如果参数是字符串
            output = transCode && ~transCode.indexOf(trans[transName])
        }else {
            console.log('渠道参数类型不是Array或者String')
        }
        return output
    },
    /**
     * @description 获取当前渠道名称
     * @param { object } tansMap 渠道码map
     * @returns { undefined | string } 返回为渠道名称or返回undefined
     */
    getTransPort: (tansMap = trans) => {
        let _result
        let transCode = Helper.urlToObj(location.href)['_trans_']
        if(!transCode || typeof transCode.indexOf !== 'function') return _result
        for(let trans in tansMap){
            if(transCode.indexOf(tansMap[trans]) > -1 ) _result = trans
        }
        return _result
    },

    /**
     * @description 获取页面trans码
     */
    getTransCode: () => {
        let _result = ""

        _result = Helper.urlToObj(location.href)['_trans_']

        return _result
    }
}